export default __webpack_public_path__ + "static/media/cards_flips_5.2aad3d33.mp3";